import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Header, Footer } from "./components/Chrome";
import { seoFor } from "./data/site";
import HomePage from "./pages/HomePage";
import MenuPage from "./pages/MenuPage";
import LokasiPage from "./pages/LokasiPage";
import TentangPage from "./pages/TentangPage";
import KontakPage from "./pages/KontakPage";
import NotFoundPage from "./pages/NotFoundPage";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/menu" element={<MenuPage />} />
      <Route path="/lokasi" element={<LokasiPage />} />
      <Route path="/tentang" element={<TentangPage />} />
      <Route path="/kontak" element={<KontakPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export function Site() {
  return (
    <>
      <Header />
      <main id="konten-utama">
        <AppRoutes />
      </main>
      <Footer />
    </>
  );
}

function PageEffects() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = seoFor(pathname).title;
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <PageEffects />
      <Site />
    </BrowserRouter>
  );
}
